import React from 'react';
import { PageData, PageDataParams } from './page-data';
import { stripHtml } from '../common/helpers';
import {
  TagResult,
  RawFixedOptionPageData,
  RawFixedOptions,
  RawFixedOption,
} from '../common/page-data';
import { renderToString } from 'react-dom/server';
import styled from '@emotion/styled';

const Description = styled.div`
  comment: Description;
  grid-area: Description;
  flex-grow: 0;
  flex-shrink: 0;
  color: var(--Description-Foreground);
  background-color: var(--Description-Background);
  padding: 1em;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  user-select: none;
`;
export type FixedOptions = RawFixedOptions;
export type FixedOption = RawFixedOption;

export class FixedOptionData extends PageData {
  public get question(): string {
    return this._question as string;
  }
  private _reason: string;
  public get reason(): string {
    return this._reason;
  }

  private _answer: string;
  public get answer(): string {
    return this._answer;
  }
  public set answer(value: string) {
    this._answer = value;
  }
  private _tagId: string;
  private get tagId(): string {
    return this._tagId;
  }
  private _options: FixedOptions;
  public get options(): FixedOptions {
    return this._options;
  }
  public get textDescription(): string {
    return stripHtml(renderToString(this.descriptionElement));
  }

  public get rawData(): RawFixedOptionPageData {
    const options = this._options;
    const playStats = this.playStats;

    const raw: RawFixedOptionPageData = {
      ...(this._rawPageData as RawFixedOptionPageData),
      options,
      playStats,
    };

    return raw;
  }

  private get correct(): boolean {
    return this.options[this.answer]?.selected;
  }
  public get tagResults(): TagResult[] {
    const correct = this.correct;

    const tagResults: TagResult[] = [
      { tagId: this.tagId, name: this.tagId, correct },
    ];

    return tagResults;
  }

  public reset(): void {
    Object.values(this.options).forEach((option) => {
      option.selected = false;
    });
  }

  public constructor(params: PageDataParams) {
    super(params);

    const { rawPageData } = params;
    const { options, answer, tagId, reason } =
      rawPageData as RawFixedOptionPageData;

    this._tagId = tagId;
    this._options = options;
    this._answer = answer;
    this._reason = reason;
  }

  public get descriptionElement(): JSX.Element {
    const ret = <Description>{this.question as string}</Description>;

    return ret;
  }

  public get score(): number {
    return this.correct ? 1 : 0;
  }
}
